module.exports = __webpack_public_path__ + "static/media/PlusBlue.84e0c3da.svg";